
import Button from '@/ui-kit/components/button';
import Gutter from '@/ui-kit/components/gutter';
import Typography from '@/ui-kit/components/typography';
import {
  StyleSizeType,
  StyleColorSchemeType,
  StylePositionType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import { track } from '@/utils/analytics';
import { TypographyType } from '@/ui-kit/components/typography/enums';

export default {
  name: 'SignInButton',
  components: {
    Button,
    Gutter,
    Typography,
  },
  props: {
    provider: {
      type: String,
      required: true,
    },
    colorScheme: {
      type: String,
      default: StyleColorSchemeType.White,
    },
    textColorScheme: {
      type: String,
      default: StyleColorSchemeType.Gray,
    },
  },
  data: () => ({
    StylePositionType,
    StyleSizeType,
    StyleColorSchemeType,
    ButtonFillType,
    TypographyType,
    StyleFontWeightType,
  }),
  methods: {
    trackSSOClick(provider) {
      track(`${provider} SSO_Button click`);
    },
  },
};
